const Reducer = (state, action) => {
  switch (action.type) {
    case 'SET_BOOKING':
      return {
        ...state,
        booking: action.payload,
      }
    case 'SET_PROPERTY':
      return {
        ...state,
        property: action.payload,
      }
    case 'SET_USER':
      return {
        ...state,
        user: action.payload,
      }
    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload,
      }
    case 'SET_START_DATE':
      return { 
        ...state,
        start_date: action.payload
      }
    case 'SET_END_DATE':
      return {
        ...state,
        end_date: action.payload
      }
    case 'SET_OVER_12_MONTHS':
      return {
        ...state,
        over_12_months: action.payload
      }
    case 'SET_HOW_MANY_PEOPLE':
      return {
        ...state,
        how_many_people: action.payload
      }
    case 'SET_AGE':
      return {
        ...state,
        age: action.payload
      }
    case 'SET_GENDER':
      return {
        ...state,
        gender: action.payload
      }
    case 'SET_NATIONALITY':
      return {
        ...state,
        nationality: action.payload
      }
    case 'SET_PROFESSION':
      return {
        ...state,
        profession: action.payload
      }
    case 'SET_ABOUT_YOURSELF':
      return {
        ...state,
        about_yourself: action.payload
      }
    case 'SET_FLEXIBILITY_STATUS':
      return {
        ...state,
        flexibility_status: action.payload
      }
    case 'SET_CURRENT_STEP':
      return {
        ...state,
        current_step: action.payload
      }
    case 'SET_PAYMENT_TYPE':
      return {
        ...state,
        payment_type: action.payload
      }
    case 'SET_TERMS_AND_CONDITIONS':
      return {
        ...state,
        terms_and_conditions: action.payload
      }
    case 'SET_TENANT_PROPOSAL':
      return {
        ...state,
        tenant_proposal: action.payload
      }
    case 'SET_CARD_HOLDER_NAME':
      return {
        ...state,
        card_holder_name: action.payload
      }
    case 'SET_CARD_HOLDER_EMAIL':
      return {
        ...state,
        card_holder_email: action.payload
      }
    case 'SET_CARD_HOLDER_ADDRESS':
      return {
        ...state,
        card_holder_address: action.payload
      }
    case 'SET_CARD_HOLDER_CITY':
      return {
        ...state,
        card_holder_city: action.payload
      }
    case 'SET_CARD_HOLDER_ZIP':
      return {
        ...state,
        card_holder_zip: action.payload
      }
    case 'SET_CARD_HOLDER_COUNTRY':
      return {
        ...state,
        card_holder_country: action.payload
      }
    case 'SET_IS_RECEIPT_FILE_UPLOADED':
       return {
        ...state,
        is_receipt_file_uploaded: action.payload
      }
    case 'SET_NEW_BOOKING_STATE':
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export default Reducer
